import { Drawer as MantineDrawer } from '@mantine/core';
import classes from './drawer.module.scss';

export const Drawer = MantineDrawer.extend({
  classNames: classes,
});
